// First pass: identifiable bags in the owner's two snack-rack photographs.
// Obscured flavors, sizes and prices need owner confirmation before adding.
export const snackBrands = [
  { id: 'better-made', name: 'Better Made', categoryLabel: 'Detroit’s potato chips' },
  { id: 'lays', name: "Lay's", categoryLabel: 'Potato chips' },
  { id: 'doritos', name: 'Doritos', categoryLabel: 'Tortilla chips' },
  { id: 'cheetos', name: 'Cheetos', categoryLabel: 'Cheese snacks' },
  { id: 'fritos', name: 'Fritos', categoryLabel: 'Corn chips' },
].map(brand => ({ ...brand, logo: `/images/snacks/${brand.id}-logo.webp` }));

const snacksData = [
  ['better-made-original', 'better-made', 'Original', 'gold', 213, 300],
  ['better-made-wavy', 'better-made', 'Wavy', 'blue', 218, 300],
  ['better-made-no-salt', 'better-made', 'No Salt Added', 'silver', 600, 600],
  ['better-made-bbq', 'better-made', 'Barbecue', 'brown', 600, 843],
  ['better-made-hot', 'better-made', 'Red Hot Barbecue', 'red', 214, 300],
  ['lays-classic', 'lays', 'Classic', 'gold', 900, 900],
  ['lays-bbq', 'lays', 'Barbecue', 'brown', 900, 900],
  ['lays-sour-cream-onion', 'lays', 'Sour Cream & Onion', 'green', 900, 900],
  ['lays-cheddar-sour-cream', 'lays', 'Cheddar & Sour Cream', 'orange', 900, 900],
  ['lays-salt-vinegar', 'lays', 'Salt & Vinegar', 'blue', 900, 900],
  ['doritos-nacho', 'doritos', 'Nacho Cheese', 'red', 900, 900],
  ['doritos-cool-ranch', 'doritos', 'Cool Ranch', 'blue', 900, 900],
  ['doritos-spicy-sweet-chili', 'doritos', 'Spicy Sweet Chili', 'purple', 900, 900],
  ['cheetos-crunchy', 'cheetos', 'Crunchy', 'orange', 900, 900],
  ['cheetos-puffs', 'cheetos', 'Puffs', 'blue', 900, 900],
  ['fritos-original', 'fritos', 'Original', 'red', 900, 900],
  ['fritos-honey-bbq', 'fritos', 'Honey BBQ Flavor Twists', 'brown', 900, 900],
].map(([id, brandId, shortName, color, imageWidth, imageHeight]) => ({
  id, brandId, shortName, color, imageWidth, imageHeight,
  name: `${snackBrands.find(brand => brand.id === brandId).name} ${shortName}`,
  image: `/images/snacks/${id}.webp`,
}));

export default snacksData;
